<div class="active-water-app-wrapper">
    <div class="active-iframe-container">
      <iframe 
        [src]="ActiveStandardsurl | safeUrl"
        allowfullscreen>
      </iframe>
    </div>
  </div>
